import { render, staticRenderFns } from "./project-book-list.vue?vue&type=template&id=4e43ca6e&"
import script from "./project-book-list.vue?vue&type=script&lang=js&"
export * from "./project-book-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports